import React, { useState } from "react";
import {
  Button,
  Container,
  Form,
  Grid,
  Header,
  Segment,
  Message,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setIsLoggedIn } = useAuth();
  const [error, setError] = useState(null);
  // セッション切れで自動誘導された場合（sessionGuard から ?session=expired）に案内を出す
  const sessionExpired =
    new URLSearchParams(window.location.search).get("session") === "expired";

  const handleSubmit = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/login/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });
      if (!response.ok) {
        setIsLoggedIn(false);
        localStorage.setItem("isLoggedIn", false);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      // slash-app の chat API/WS を呼ぶための JWT を保存。Django 側が裏で
      // /api/auth/login/ を叩いて取得した結果。並行運用中なので payload に
      // 含まれない可能性もある (slash-app が落ちている等) ので存在チェック。
      if (data.slashapp && data.slashapp.access && data.slashapp.refresh) {
        localStorage.setItem("slashapp_access", data.slashapp.access);
        localStorage.setItem("slashapp_refresh", data.slashapp.refresh);
        if (data.slashapp.sub_id != null) {
          localStorage.setItem("slashapp_sub_id", String(data.slashapp.sub_id));
        }
      }
      setIsLoggedIn(true);
      localStorage.setItem("isLoggedIn", true);
      navigate("/");
    } catch (error) {
      setIsLoggedIn(false);
      localStorage.setItem("isLoggedIn", false);
      console.error("ログイン中にエラーが発生しました:", error);
      setError(error);
    }
  };

  return (
    <>
      <Container>
        <Grid
          textAlign="center"
          style={{ height: "100vh" }}
          verticalAlign="middle"
        >
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h2" color="teal" textAlign="center">
              SLASH ADMIN
            </Header>
            {sessionExpired && (
              <Message info>
                セッションの有効期限が切れました。お手数ですが再度ログインしてください。
              </Message>
            )}
            <Form size="large">
              <Segment stacked>
                <Form.Input
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <Form.Input
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Button color="teal" fluid size="large" onClick={handleSubmit}>
                  Login
                </Button>
              </Segment>
            </Form>
            <div style={{ height: "22px", color: "transparent" }}>
              {error && <Message color="red">ログインに失敗しました。</Message>}
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </>
  );
}

export default LoginPage;
